<template>
    <div>
        <div v-if="!response" class="no-answer">
            <span>
                Not Answered
            </span>
        </div>
        <div v-for="(choice, index) in 2"
            :key="index"
            :class="['choice', {
                selected: response != null && response[0] === (choice == 1 ? 'Yes' : 'No')
            }]">
            <span class="text">{{ choice == 1 ? 'Yes' : 'No' }}</span>
        </div>
    </div>
</template>

<script>

export default {   
    name: 'binary-partial',

    props: {
		response: {
			type: Object,
		},
    },
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
</style>
